import { render, staticRenderFns } from "./AboutStep.vue?vue&type=template&id=ce7767f8&lang=pug"
import script from "./AboutStep.vue?vue&type=script&lang=js"
export * from "./AboutStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AddressSearch: require('/home/docker/code/frontend/components/AddressSearch.vue').default,TypedDateInput: require('/home/docker/code/frontend/components/TypedDateInput.vue').default})
